import { createContext } from 'react';
import { IVideoStudios } from 'types';

export type TVideoStudiosSortBy = '' | 'NameA-Z' | 'NameZ-A';
export type TVideoStudiosCountOfItems = '12' | '24' | '48';
export type TTypeOfModalWindow = null | 'toConfirmDeleteItem' | 'success' | 'error' | 'createStudio' | 'editStudio';
export interface IFilterValues {
	searchString: string;
	sortBy: TVideoStudiosSortBy;
	countOfItems: TVideoStudiosCountOfItems;
	currentPage: number;
}

export interface IVideoStudiosState {
	videoStudios: IVideoStudios;
	searchString: string;
	sortBy: TVideoStudiosSortBy;
	countOfItems: TVideoStudiosCountOfItems;
	currentPage: number;
	IDForDeletion: string;
	IDForEdit: string;
	typeOfModalWindow: TTypeOfModalWindow;
	needRefetchStudios: boolean;
}

export const videoStudiosInitialState: IVideoStudiosState = {
	videoStudios: { videoStudiosCount: 0, videoStudios: [] },
	searchString: '',
	sortBy: '',
	countOfItems: '12',
	currentPage: 1,
	IDForDeletion: '',
	IDForEdit: '',
	typeOfModalWindow: null,
	needRefetchStudios: false,
};

export interface IVideoStudiosContext extends IVideoStudiosState {
	deleteSelectedItem(): void;
	changeSearchString(value: string): void;
	resetSelectedControls(): void;
	setSortBy(sortBy: TVideoStudiosSortBy): void;
	setCountOfItems(count: TVideoStudiosCountOfItems): void;
	changeCurrentPage(page: number): void;
	setIDForDeletion(value: string): void;
	setIDForEdit(value: string): void;
	changeTypeOfModalWindow(value: TTypeOfModalWindow): void;
	setFiltersFromQueryString(value: IFilterValues): void;
	refetchStudios(value: boolean): void;
}

export const VideoStudiosContext = createContext<IVideoStudiosContext>({
	deleteSelectedItem: () => undefined,
	changeSearchString: () => undefined,
	resetSelectedControls: () => undefined,
	setSortBy: () => undefined,
	setCountOfItems: () => undefined,
	changeCurrentPage: () => undefined,
	setIDForDeletion: () => undefined,
	setIDForEdit: () => undefined,
	changeTypeOfModalWindow: () => undefined,
	setFiltersFromQueryString: () => undefined,
	refetchStudios: () => undefined,
	...videoStudiosInitialState,
});
